import { HeadExtractoLoteria, INumeroExtracto } from "../interfaces/interfaces";
import GrillaNrosPorLoteria from "./grillaNrosPorLoteria";
import { v4 as uuid } from "uuid";

interface Iprops {
  numerosModalidad: INumeroExtracto[];
  loteriasHead: HeadExtractoLoteria[];
}

const ColumnExtracto = (props: Iprops) => {
  const { loteriasHead, numerosModalidad } = props;

  return <>{getContainerExtracto(loteriasHead)}</>;

  function getContainerExtracto(loteriasHead: HeadExtractoLoteria[]) {
    let itemsGral: JSX.Element[] = [];

    for (const i of loteriasHead) {
      let keyC = `colkey${i.idModalidad}${uuid()}`;

      let numerosLoteria = numerosModalidad
        .filter((numero) => numero.NroLoteria === i.NroLoteria)
        .sort((a, b) => a.Ubicacion - b.Ubicacion);

      if (i.NroLoteria == 1) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoER"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }
      if (i.NroLoteria == 2) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoCABA"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }
      if (i.NroLoteria == 3) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoBSAS"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }
      if (i.NroLoteria == 4) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoORO"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }

      if (i.NroLoteria == 5) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoSF"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }
      if (i.NroLoteria == 6) {
        itemsGral.push(
          <GrillaNrosPorLoteria
            key={keyC}
            idExtractos="ExtractoC"
            loteria={i}
            numerosLoteria={numerosLoteria}
          />
        );
      }
    }

    return (
      <>
        <div className="extractosGral">{itemsGral}</div>
      </>
    );
  }
};

export default ColumnExtracto;
